import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../utilities/rtk-query';
import {
  CarrierAccesPayload,
  CompanyPermissions,
  ContactUsPayload,
} from './permissionsType';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const permissionsApi = createApi({
  reducerPath: 'permissionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_REGISTRATION_SERVICE_URL!,
  }),
  tagTypes: [],
  endpoints: (builder) => ({
    getCarrierPermissions: builder.query<
      CompanyPermissions,
      string | undefined
    >({
      query: (carrierId) => {
        if (!carrierId) {
          throw new Error('CarrierId is required');
        }
        return {
          url: `/carrier/${carrierId}`,
          method: 'GET',
        };
      },
    }),
    requestCarrierAccess: builder.mutation<any, CarrierAccesPayload>({
      query: (payload) => {
        return {
          url: `/users/${payload.userEmail}/request-carrier-access`,
          method: 'POST',
          data: payload,
        };
      },
    }),
    sendOrderInquiry: builder.mutation<any, ContactUsPayload>({
      query: (payload: ContactUsPayload) => {
        return {
          url: `/users/${encodeURIComponent(
            payload.userEmail
          )}/carrier-inquiry`,
          method: 'POST',
          data: payload,
        };
      },
    }),
  }),
});

interface UserPermissionsLevelFormProps {
  hideBackdrop?: boolean;
  formType?: 'splash' | 'upgrade';
  permissionRequested?: boolean;
}

interface UserPermissionsLevelFormConfig {
  dialogOpen: boolean;
  config: UserPermissionsLevelFormProps;
}

const permissionDialogInitialState: UserPermissionsLevelFormConfig = {
  dialogOpen: false,
  config: {
    hideBackdrop: true,
    formType: 'splash',
  },
};

export const permissionDialogSlice = createSlice({
  name: 'permissionDialog',
  initialState: permissionDialogInitialState,
  reducers: {
    openPermissionDialog: (
      state,
      action: PayloadAction<UserPermissionsLevelFormProps | undefined>
    ) => {
      state.dialogOpen = true;
      if (action.payload) {
        state.config = { ...state.config, ...action.payload };
      }
    },
    onAccessRequested: (state, action) => {
      state.config.permissionRequested = action.payload;
    },
    closePermisssionDialog: (state) => {
      state.dialogOpen = false;
    },
  },
});

export const {
  useGetCarrierPermissionsQuery,
  useRequestCarrierAccessMutation,
  useSendOrderInquiryMutation,
} = permissionsApi;

export const {
  openPermissionDialog,
  onAccessRequested,
  closePermisssionDialog,
} = permissionDialogSlice.actions;

export default permissionsApi;
